import { datadogRum } from '@datadog/browser-rum';
import * as stripe from '@stripe/stripe-js';
import axios from 'axios';
import React, { FC, useState } from 'react';
import { useAsync } from 'react-use';
import styled from 'styled-components';

import { ApiEndpoints } from '@utils/endpoints';

import { useAuth } from '@providers/AuthProvider';

import theme from '@theme/FolxTheme';

import MedicationBillError from './MedicationBillError';

interface IFfsMedPaymentProps {
	batchId: string;
}

const PurchaseFfsMedContainer = styled.div`
	padding: 20px;
	justify-content: center;
	font-size: ${theme.fontSizes.body.lg};
	color: #0a2540;
	width: 480px;
`;

const FfsMedPayment: FC<IFfsMedPaymentProps> = ({ batchId }) => {
	const [loadingText, setLoadingText] = useState('Loading...');
	const [error, setError] = useState(false);

	const auth = useAuth();

	useAsync(async () => {
		if (!auth?.initialized) {
			return;
		}

		try {
			const sessionId = (
				await axios.post<{ checkoutSessionId: string }>(
					`${ApiEndpoints.stripe!}/med-session`,
					{
						batchId,
					},
					{
						headers: {
							'Content-Type': 'application/json',
							Accept: 'application/json',
						},
					}
				)
			).data.checkoutSessionId;

			const pubKey = auth?.email?.toLowerCase().endsWith('@folxhealth.com')
				? process.env.GATSBY_STRIPE_TEST_PUBLISHABLE_KEY
				: process.env.GATSBY_STRIPE_PUBLISHABLE_KEY;
			const stripeClient = await stripe.loadStripe(pubKey!);
			stripeClient?.redirectToCheckout({
				sessionId,
			});
		} catch (error) {
			datadogRum.addError(error);
			setError(true);
			setLoadingText('Something went wrong. Please reach out to support in the Message Center.');
		}
	}, [auth?.initialized]);

	return (
		<>
			{error ? (
				<MedicationBillError />
			) : (
				<PurchaseFfsMedContainer>{loadingText}</PurchaseFfsMedContainer>
			)}
		</>
	);
};

export default FfsMedPayment;
